import { memo } from 'react';

import { IconWebhook } from '@components/icons/webhook';
import { SquareImage } from '@components/square-image';
import { useScopedTranslate } from '@locale/translate';

import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import { TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

const ACTION_TYPE = ACTION_TYPES.webhook;

export const Node = memo((node: TravellerJourneyNode<typeof ACTION_TYPE>) => {
  const { t } = useScopedTranslate(nodeLocale);
  const integration = node.data.integration;
  const endpointName = integration?.name ?? getActionLabel(ACTION_TYPE);
  const integrationName = integration?.integrationName;

  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        node={node}
        label={endpointName}
        subLabel={integrationName}
        descriptionText={node.data.description || t('description')}
        icon={
          integration?.thumbnail ? (
            <SquareImage src={integration.thumbnail} />
          ) : (
            <IconWebhook color="green200" />
          )
        }
      >
        <NodeActions node={node} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
});

const nodeLocale = {
  en: {
    description: 'Wait for incoming webhook',
  },
};
